
$(document).ready(function(){
    var swiper = new Swiper(".mySwiper-review", {
        slidesPerView: 1,
        spaceBetween: 12,
        centeredSlides: !0,
        direction: 'horizontal',
        loop: !1,
        pagination: { el: ".swiper-pagination-review", clickable: !0 },
        navigation: { nextEl: ".swiper-button-next-review", prevEl: ".swiper-button-prev-review" },
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 0, centeredSlides: !0, loop: !0, },
          1024: { slidesPerView: 3, spaceBetween: 0, centeredSlides: !0, loop: !0, } },
    });


  var swiperproduct = new Swiper(".mySwiper-product-slider", {
        slidesPerView: 2,
        spaceBetween: 8,
        centeredSlides: !1,
        direction: 'horizontal',
        loop: !1,
        pagination: { el: ".swiper-pagination-review", clickable: !0 },
        navigation: { nextEl: ".swiper-button-next-review", prevEl: ".swiper-button-prev-review" },
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 20, centeredSlides: !1 },
          1024: { slidesPerView: 4, spaceBetween: 20, centeredSlides: !1 } },
    });


  jQuery(".footer-block__heading").click(function(){
      console.log('footer-block__heading click');
      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        jQuery(this).next().removeClass("active");
      } else {
        $(this).addClass("open");
        jQuery(this).next().addClass("active");
      }
  });




});

/* Custom sizechart */
    document.addEventListener("DOMContentLoaded", function () {
      /* Handle gi-step-stwo*/
      const stepTwoSection = document.getElementById("gi-step-two");
      if (stepTwoSection) {
        const steps = stepTwoSection.querySelectorAll(
          ".gi-steps__bar .gi-step"
        );
        const tables = {
          0: document.getElementById("gi-size-standard"),
          1: document.getElementById("gi-size-long"),
          2: document.getElementById("gi-size-hefty"),
        };
        steps.forEach((step, index) => {
          step.addEventListener("click", () => {
            steps.forEach((s) => s.classList.remove("active"));
            Object.values(tables).forEach((table) => {
              if (table) table.style.display = "none";
            });

            step.classList.add("active");
            if (tables[index]) tables[index].style.display = "block";
          });
        });
      }

        /* Handle gi-step*/
    const globalSteps = document.querySelectorAll(".gi-steps__bar .gi-step");

const sectionsMap = {
  0: document.getElementById("gi-step-one"),
  1: document.getElementById("gi-step-two"),
  2: document.getElementById("gi-step-three"),
};

globalSteps.forEach((step, index) => {
  step.addEventListener("click", () => {
    const targetSection = sectionsMap[index];
    globalSteps.forEach((s) => s.classList.remove("active"));

    step.classList.add("active");

    if (targetSection) {
      targetSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  });
});
    });

